if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const image = event.target.closest('.product-media-modal__content img');
        if (image && this.hasAttribute('open')) this.hide();
      });
    }

    hide() {
      const container = this.querySelector('[role="document"]');
      if (container) {
        container.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        container.querySelectorAll('img').forEach((image) => {
          image.style.removeProperty('transform');
          image.style.removeProperty('transform-origin');
        });
      }
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute('data-media-id');
      if (!mediaId) return;
      this.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
      });
      const activeMedia = Array.from(this.querySelectorAll('[data-media-id]'))
        .find((element) => element.getAttribute('data-media-id') === mediaId);
      if (!activeMedia) return;
      const container = this.querySelector('[role="document"]');
      if (container) {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      }
      activeMedia.scrollIntoView({ block: 'center', inline: 'center', behavior: 'instant' });
      if (container) container.scrollLeft = Math.max(0, (activeMedia.getBoundingClientRect().width - container.clientWidth) / 2);
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMedia.querySelector('template')?.content.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  });
}